export const SaleConfig: Config = {
  STORE_WITHDRAWAL: 'STORE_WITHDRAWAL',
  HOME_DELIVERY: 'HOME_DELIVERY',
  ENTITIES_INVENTORY_ADJUST: [
    'SPSA-445',
    'SPSA-917',
    'SPSA-901',
    'SPSA-902',
    'SPSA-956',
    'SPSA-946',
    'SPSA-959'
  ],
  typeSend: [
    { id: 'STORE_WITHDRAWAL', value: 'Retiro en tienda' },
    { id: 'HOME_DELIVERY', value: 'Despacho a domicilio' }
  ],
  DISPATCH_DEFAULT: 'NORMAL',
  productType:
    {
      /**
       * ST = Producto de venta
       */
      ST: 'ST',
      /**
       * SV = Servicio adicional
       */
      SV: 'SV',
      /**
       * FL = Flete
       */
      FL: 'FL'
    }
};

interface Config {
  STORE_WITHDRAWAL: 'STORE_WITHDRAWAL' | 'HOME_DELIVERY';
  HOME_DELIVERY: 'STORE_WITHDRAWAL' | 'HOME_DELIVERY';
  typeSend: any[];
  ENTITIES_INVENTORY_ADJUST: any[];
  productType?: any;
  DISPATCH_DEFAULT: 'NORMAL';
}

